var map = {
	"./Kentico.svg": 24984,
	"./Kontent.svg": 56754,
	"./Strapi.svg": 34492,
	"./about-skating-butler.svg": 11525,
	"./amazon.svg": 38819,
	"./atom.svg": 9988,
	"./backgrounds/background-line-arrow-head.svg": 63423,
	"./backgrounds/background-line.svg": 51788,
	"./backgrounds/cloud-dots-bottom.svg": 88059,
	"./backgrounds/cloud-dots-top.svg": 2287,
	"./backgrounds/cloud-page_header-dots-a.svg": 17407,
	"./backgrounds/cloud-page_header-dots-b.svg": 38380,
	"./backgrounds/cloud-page_header-dots-c.svg": 85741,
	"./backgrounds/cloud-page_proof-arrow.svg": 10363,
	"./backgrounds/cloud-page_proof-watermark.svg": 18062,
	"./backgrounds/concierge-form-bg-left-bottom.svg": 9913,
	"./backgrounds/concierge-form-bg-left-center.svg": 71371,
	"./backgrounds/concierge-form-bg-right-center.svg": 58136,
	"./backgrounds/concierge-page_header-a.svg": 27732,
	"./backgrounds/concierge-page_header-b.svg": 99239,
	"./backgrounds/concierge-page_header-c.svg": 59702,
	"./backgrounds/cta-block-hands-a.svg": 55218,
	"./backgrounds/cta-block-hands-b.svg": 60257,
	"./backgrounds/cta-block-hands-c.svg": 48016,
	"./backgrounds/home_dots.svg": 20923,
	"./ball-being-rolled.svg": 59965,
	"./bg-home.svg": 66338,
	"./checkmark.svg": 11994,
	"./codesandbox.svg": 64205,
	"./color-blocks.svg": 6007,
	"./concierge-account-management.svg": 65942,
	"./concierge-audit.svg": 30222,
	"./concierge-review.svg": 40497,
	"./concierge-slack-channel.svg": 21601,
	"./concierge-ticket-prioritization.svg": 39331,
	"./concierge-training.svg": 4215,
	"./contentful.svg": 75979,
	"./contentstack.svg": 64906,
	"./datocms.svg": 44672,
	"./diagram/cdn-mini.svg": 37446,
	"./diagram/cdn-new.svg": 92571,
	"./diagram/cdn.svg": 17302,
	"./diagram/cli-big.svg": 70684,
	"./diagram/cli-mini.svg": 10847,
	"./diagram/cms-big.svg": 62293,
	"./diagram/cms-documents.svg": 62057,
	"./diagram/cms-mini.svg": 78368,
	"./diagram/cms.svg": 67480,
	"./diagram/code-documents.svg": 99971,
	"./diagram/content-creator.svg": 37407,
	"./diagram/database.svg": 62406,
	"./diagram/developer.svg": 73085,
	"./diagram/filesystem.svg": 74960,
	"./diagram/react.svg": 34334,
	"./diagram/user-new-small.svg": 40659,
	"./diagram/user-new.svg": 61345,
	"./diagram/user.svg": 44780,
	"./docs-keyvisual-conceptual-guides.svg": 1747,
	"./docs-keyvisual-homepage.svg": 53841,
	"./docs-keyvisual-how-to-guides.svg": 49489,
	"./docs-keyvisual-reference-guides.svg": 29822,
	"./docs-keyvisual-tutorials.svg": 30646,
	"./drupal.svg": 37349,
	"./gatsby-days-logo.svg": 57163,
	"./guides-astronaut-butler.svg": 11865,
	"./guides-markdown.svg": 29162,
	"./guides-react-hero-bottom.svg": 67761,
	"./guides-react.svg": 7850,
	"./guides-stars.svg": 81620,
	"./hand-dropping-ball.svg": 89428,
	"./hosting.svg": 84511,
	"./icon-apps.svg": 581,
	"./icon-data.svg": 77217,
	"./icon-deployment.svg": 64772,
	"./icon-link.svg": 9901,
	"./icon-performance.svg": 69077,
	"./icons/article.svg": 87828,
	"./icons/md-arrow-forward.svg": 42917,
	"./integrations-circle.svg": 66239,
	"./integrations-hexagon.svg": 91069,
	"./integrations-polygon.svg": 53535,
	"./integrations-two-squares.svg": 34892,
	"./jekyll.svg": 164,
	"./light-purple-dot.svg": 29758,
	"./logo.svg": 32794,
	"./markdown.svg": 30456,
	"./monogram.svg": 9987,
	"./netlify-grayscale.svg": 14019,
	"./netlify.svg": 9350,
	"./nextjs.svg": 87737,
	"./pictures/cloud-page_cms-previews-desktop.svg": 76443,
	"./pictures/cloud-page_cms-previews-mobile.svg": 65215,
	"./pictures/cloud-page_deploy-previews-desktop.svg": 2263,
	"./pictures/cloud-page_deploy-previews-mobile.svg": 7331,
	"./pictures/cloud-page_incremental-builds-desktop.svg": 84502,
	"./pictures/cloud-page_incremental-builds-mobile.svg": 45388,
	"./pictures/cloud-page_lighthouse-reports-desktop.svg": 98306,
	"./pictures/cloud-page_lighthouse-reports-mobile.svg": 10816,
	"./pwa.svg": 14461,
	"./pwa_card.svg": 79722,
	"./react.svg": 16840,
	"./sanitize.svg": 70666,
	"./sanity.svg": 80221,
	"./silly-site-award.svg": 57220,
	"./silly-site-background.svg": 38617,
	"./silly-site-challenge-pattern-light.svg": 7750,
	"./silly-site-challenge-pattern.svg": 41181,
	"./silly-site-shapes.svg": 69475,
	"./silly-site-swag.svg": 95135,
	"./source.svg": 6308,
	"./support-cloud-knowledge-base.svg": 40351,
	"./support-form-background.svg": 2336,
	"./support-form-hand.svg": 31935,
	"./support-open-source-docs.svg": 25639,
	"./support-product-roadmap.svg": 57449,
	"./support-status-page.svg": 36033,
	"./use-case-ellipse-2.svg": 5749,
	"./use-case-ellipse.svg": 99480,
	"./use-case-polygon.svg": 10836,
	"./use-case-rectangle.svg": 10193,
	"./why-gatsby-bg-block-1.svg": 22126,
	"./why-gatsby-bg-block-2.svg": 70477,
	"./why-gatsby-blazing-fast-websites.svg": 64920,
	"./why-gatsby-delight-developers.svg": 37172,
	"./why-gatsby-ensure-safety.svg": 58866,
	"./why-gatsby-exceed-expectations.svg": 87271,
	"./why-gatsby-stars.svg": 9624,
	"./why-gatsby-start-quickly.svg": 70248,
	"./wordpress.svg": 58712
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8439;